import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import SegmentIntersector from './SegmentIntersector';
import ArrayList from '../../../../java/util/ArrayList';
var NodingIntersectionFinder = /*#__PURE__*/function () {
  function NodingIntersectionFinder() {
    _classCallCheck(this, NodingIntersectionFinder);
    NodingIntersectionFinder.constructor_.apply(this, arguments);
  }
  _createClass(NodingIntersectionFinder, [{
    key: "setCheckEndSegmentsOnly",
    value: function setCheckEndSegmentsOnly(isCheckEndSegmentsOnly) {
      this._isCheckEndSegmentsOnly = isCheckEndSegmentsOnly;
    }
  }, {
    key: "getIntersectionSegments",
    value: function getIntersectionSegments() {
      return this._intSegments;
    }
  }, {
    key: "count",
    value: function count() {
      return this._intersectionCount;
    }
  }, {
    key: "getIntersections",
    value: function getIntersections() {
      return this._intersections;
    }
  }, {
    key: "setFindAllIntersections",
    value: function setFindAllIntersections(findAllIntersections) {
      this._findAllIntersections = findAllIntersections;
    }
  }, {
    key: "setKeepIntersections",
    value: function setKeepIntersections(keepIntersections) {
      this._keepIntersections = keepIntersections;
    }
  }, {
    key: "getIntersection",
    value: function getIntersection() {
      return this._interiorIntersection;
    }
  }, {
    key: "processIntersections",
    value: function processIntersections(e0, segIndex0, e1, segIndex1) {
      if (!this._findAllIntersections && this.hasIntersection()) return null;
      var isSameSegString = e0 === e1;
      var isSameSegment = isSameSegString && segIndex0 === segIndex1;
      if (isSameSegment) return null;
      if (this._isCheckEndSegmentsOnly) {
        var isEndSegPresent = NodingIntersectionFinder.isEndSegment(e0, segIndex0) || NodingIntersectionFinder.isEndSegment(e1, segIndex1);
        if (!isEndSegPresent) return null;
      }
      var p00 = e0.getCoordinate(segIndex0);
      var p01 = e0.getCoordinate(segIndex0 + 1);
      var p10 = e1.getCoordinate(segIndex1);
      var p11 = e1.getCoordinate(segIndex1 + 1);
      var isEnd00 = segIndex0 === 0;
      var isEnd01 = segIndex0 + 2 === e0.size();
      var isEnd10 = segIndex1 === 0;
      var isEnd11 = segIndex1 + 2 === e1.size();
      this._li.computeIntersection(p00, p01, p10, p11);
      var isInteriorInt = this._li.hasIntersection() && this._li.isInteriorIntersection();
      var isInteriorVertexInt = false;
      if (!this._isInteriorIntersectionsOnly) {
        var isAdjacentSegment = isSameSegString && Math.abs(segIndex1 - segIndex0) <= 1;
        isInteriorVertexInt = !isAdjacentSegment && NodingIntersectionFinder.isInteriorVertexIntersection(p00, p01, p10, p11, isEnd00, isEnd01, isEnd10, isEnd11);
      }
      if (isInteriorInt || isInteriorVertexInt) {
        this._intSegments = new Array(4).fill(null);
        this._intSegments[0] = p00;
        this._intSegments[1] = p01;
        this._intSegments[2] = p10;
        this._intSegments[3] = p11;
        this._interiorIntersection = this._li.getIntersection(0);
        if (this._keepIntersections) this._intersections.add(this._interiorIntersection);
        this._intersectionCount++;
      }
    }
  }, {
    key: "hasIntersection",
    value: function hasIntersection() {
      return this._interiorIntersection !== null;
    }
  }, {
    key: "isDone",
    value: function isDone() {
      if (this._findAllIntersections) return false;
      return this._interiorIntersection !== null;
    }
  }, {
    key: "setInteriorIntersectionsOnly",
    value: function setInteriorIntersectionsOnly(isInteriorIntersectionsOnly) {
      this._isInteriorIntersectionsOnly = isInteriorIntersectionsOnly;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [SegmentIntersector];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._findAllIntersections = false;
      this._isCheckEndSegmentsOnly = false;
      this._keepIntersections = true;
      this._isInteriorIntersectionsOnly = false;
      this._li = null;
      this._interiorIntersection = null;
      this._intSegments = null;
      this._intersections = new ArrayList();
      this._intersectionCount = 0;
      var li = arguments[0];
      this._li = li;
      this._interiorIntersection = null;
    }
  }, {
    key: "createAllIntersectionsFinder",
    value: function createAllIntersectionsFinder(li) {
      var finder = new NodingIntersectionFinder(li);
      finder.setFindAllIntersections(true);
      return finder;
    }
  }, {
    key: "isInteriorVertexIntersection",
    value: function isInteriorVertexIntersection() {
      if (arguments.length === 4) {
        var p0 = arguments[0],
          p1 = arguments[1],
          isEnd0 = arguments[2],
          isEnd1 = arguments[3];
        if (isEnd0 && isEnd1) return false;
        if (p0.equals2D(p1)) return true;
        return false;
      } else if (arguments.length === 8) {
        var p00 = arguments[0],
          p01 = arguments[1],
          p10 = arguments[2],
          p11 = arguments[3],
          isEnd00 = arguments[4],
          isEnd01 = arguments[5],
          isEnd10 = arguments[6],
          isEnd11 = arguments[7];
        if (NodingIntersectionFinder.isInteriorVertexIntersection(p00, p10, isEnd00, isEnd10)) return true;
        if (NodingIntersectionFinder.isInteriorVertexIntersection(p00, p11, isEnd00, isEnd11)) return true;
        if (NodingIntersectionFinder.isInteriorVertexIntersection(p01, p10, isEnd01, isEnd10)) return true;
        if (NodingIntersectionFinder.isInteriorVertexIntersection(p01, p11, isEnd01, isEnd11)) return true;
        return false;
      }
    }
  }, {
    key: "createInteriorIntersectionCounter",
    value: function createInteriorIntersectionCounter(li) {
      var finder = new NodingIntersectionFinder(li);
      finder.setInteriorIntersectionsOnly(true);
      finder.setFindAllIntersections(true);
      finder.setKeepIntersections(false);
      return finder;
    }
  }, {
    key: "createIntersectionCounter",
    value: function createIntersectionCounter(li) {
      var finder = new NodingIntersectionFinder(li);
      finder.setFindAllIntersections(true);
      finder.setKeepIntersections(false);
      return finder;
    }
  }, {
    key: "isEndSegment",
    value: function isEndSegment(segStr, index) {
      if (index === 0) return true;
      if (index >= segStr.size() - 2) return true;
      return false;
    }
  }, {
    key: "createAnyIntersectionFinder",
    value: function createAnyIntersectionFinder(li) {
      return new NodingIntersectionFinder(li);
    }
  }, {
    key: "createInteriorIntersectionsFinder",
    value: function createInteriorIntersectionsFinder(li) {
      var finder = new NodingIntersectionFinder(li);
      finder.setFindAllIntersections(true);
      finder.setInteriorIntersectionsOnly(true);
      return finder;
    }
  }]);
  return NodingIntersectionFinder;
}();
export { NodingIntersectionFinder as default };